import React from 'react';
import { Card, Descriptions, Form, Input, Button, message, Alert } from 'antd';

export default () => {
    const [profile, setProfile] = React.useState(null);
    const [saving, setSaving] = React.useState(false);
    const [form] = Form.useForm();

    // 品牌分账商户号是租户级 KEY，仅租户超管可配置（连锁版消费）
    const isSuper = !window.__baseInfo?.isSub;
    const isChain = profile?.versionId === 3;

    const getAccountDetail = async () => {
        const response = await fetch('/api/account/detail');
        const result = await response.json();
        if (result && result.success) {
            setProfile(result.data);
            form.setFieldsValue({ brandMchid: result.data?.brandMchid || '' });
        }
    };

    React.useEffect(() => {
        getAccountDetail();
    }, []);

    const submit = async () => {
        const values = await form.validateFields();
        setSaving(true);
        try {
            const response = await fetch('/api/account/brand-mchid', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ mchid: values.brandMchid || '' }),
            });
            const result = await response.json();
            if (result?.success) {
                message.success('已保存');
                getAccountDetail();
            } else {
                message.error(result.data || '保存失败');
            }
        } finally {
            setSaving(false);
        }
    };

    return (
        <div>
            <h2 className="admin-page-title">账户资料</h2>

            <Card size="small" style={{ marginBottom: 16 }}>
                <Descriptions column={1} size="small">
                    <Descriptions.Item label="系统版本">{profile?.version?.title || '-'}</Descriptions.Item>
                    <Descriptions.Item label="账户类型">{profile?.type === 1 ? '个人' : '企业'}</Descriptions.Item>
                    <Descriptions.Item label="主体名称">{profile?.companyName || profile?.realname || '-'}</Descriptions.Item>
                </Descriptions>
            </Card>

            <Card size="small" title="品牌分账">
                {isChain && isSuper ? (
                    <>
                        <Alert
                            type="info"
                            showIcon
                            style={{ marginBottom: 12 }}
                            message="品牌分账主商户号（品牌 KEY），仅作品牌分账 brand_mchid 维度，可收可不收；留空保存则回退总店商户号。"
                        />
                        <Form form={form} layout="vertical">
                            <Form.Item
                                label="品牌分账商户号"
                                name="brandMchid"
                                rules={[
                                    {
                                        pattern: /^\d{8,16}$/,
                                        message: '应为 8~16 位数字，留空则回退总店商户号',
                                    },
                                ]}
                            >
                                <Input placeholder="如 1717235876，留空则回退总店商户号" maxLength={16} />
                            </Form.Item>
                            <Button type="primary" onClick={submit} loading={saving}>
                                保存
                            </Button>
                        </Form>
                    </>
                ) : (
                    <Descriptions column={1} size="small">
                        <Descriptions.Item label="品牌分账商户号">
                            {profile?.brandMchid || '未配置（回退总店商户号）'}
                        </Descriptions.Item>
                    </Descriptions>
                )}
            </Card>
        </div>
    );
}
